import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Close } from "@faire/web/slate/icons/foundation/Close";
import * as React from "react";

import { CloseWrapper } from "../styles";

interface ClearButtonProps<T extends string> {
  value?: T;
  onClear?: () => void;
  helper?: string;
}

export const ClearButton = <T extends string>({
  value,
  onClear,
  helper,
}: ClearButtonProps<T>) => {
  const { strictLocalize } = useStrictLocalization();
  if (value && onClear) {
    return (
      <CloseWrapper
        onClick={onClear}
        $hasHelperText={!!helper}
        data-test-id="option-clear-button"
        type="button"
      >
        <Close
          color={Core.icon.subdued}
          titleAccess={strictLocalize({
            defaultMessage: "Clear selection",
            description: {
              text: "Description of icon to clear the selection for screen readers",
            },
          })}
        />
      </CloseWrapper>
    );
  }
  return null;
};
